import { preEligibilityDesktopFunnelDefinition } from "./definitions/desktopDefinition";
import { preEligibilityMobileFunnelDefinition } from "./definitions/mobileDefinition";
import { isMobileOnly } from "react-device-detect";
import { trackProductSelected, trackViewItem } from "../../modules/analytics/track";
import { appSettingsSnapshot } from "../../settings";
import { useBrandSnapshot } from "v2/modules/branding";
import { reportFunnelInit } from "v2/api/funnel-metrics";
import { Cookies } from "react-cookie";
import { AIRHELP_GLOBAL_COOKIE_DOMAIN } from "constants/cookies";
import useEffectOnce from "hooks/useEffectOnce";
import { ReactRouterFunnel, useFunnelInit } from "@airhelp/funnel/react-router";
const { currency } = appSettingsSnapshot();

trackViewItem({ currency });
trackProductSelected({ currency });

const cookies = new Cookies();
const funnelMetricsCookie = cookies.get("funnel_metrics");

const funnelMetricsInit = () => {
  if (!funnelMetricsCookie) {
    reportFunnelInit();
    cookies.set("funnel_metrics", "true", {
      path: "/",
      domain: AIRHELP_GLOBAL_COOKIE_DOMAIN,
    });
  }
};

export function PreEligibilityFunnel() {
  const brand = useBrandSnapshot();
  useEffectOnce(() => {
    if (!brand) {
      funnelMetricsInit();
    }
  });

  const definition = useFunnelInit(() =>
    isMobileOnly ? preEligibilityMobileFunnelDefinition : preEligibilityDesktopFunnelDefinition,
  );
  return (
    <ReactRouterFunnel
      definition={definition}
      loadingIndicator={"..."}
      notFoundStep={"Not found"}
    />
  );
}
